import React from "react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-panel">
                <h3 className="font-display text-xl font-semibold text-slate-900">
                    {message || "Are you sure?"}
                </h3>
                <p className="mt-2 text-sm text-slate-500">This action cannot be undone.</p>
                <div className="mt-6 flex justify-end gap-3">
                    <button onClick={onClose} className="btn-light">
                        Cancel
                    </button>
                    <button onClick={onConfirm} className="btn-danger">
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
